import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Textbox } from "../../models/editors/textbox.model";
import { Textarea } from "../../models/editors/textarea.model";
import { Switch } from "../../models/editors/switch.model";
import { atLeastOneLang } from "../../shared/validators/langField.validator";
import { FormControlService } from "../../shared/services/form-control.service";
import { ApiService } from "../../shared/services/api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from "../../shared/services/alert.service";
import { ContainedMany } from "../../models/editors/contained-many.model";
import { FormDetailBase } from "../../shared/components/base/form-detail/form-detail.base.component";
import { Testimonial } from "../../models/testimonials/testimonials.model";
import { Validators } from "@angular/forms";
import { EntityService } from "./../../shared/services/entity.service";

@Component({
  selector: "swb-testimonial-detail",
  templateUrl:
    "./../../shared/components/base/form-detail/form-detail.base.component.html",
  providers: [FormControlService],
  encapsulation: ViewEncapsulation.None,
})
export class TestimonialDetailComponent
  extends FormDetailBase<Testimonial>
  implements OnInit
{
  public url = "testimonials";
  protected _redirect = "./products";

  public entity = new Testimonial({});

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: "title",
        label: "Titulek",
        validators: [atLeastOneLang],
        isMultilang: true,
      }),
      new Textarea({
        key: "excerpt",
        label: "Krátký popis",
        validators: [atLeastOneLang],
        isMultilang: true,
        wysiwyg: "testimonial-excerpt",
      }),
      new Textarea({
        key: "content",
        label: "Celý popis",
        isMultilang: true,
        wysiwyg: "testimonial-content",
      }),
      new Textbox({
        key: "place",
        label: "Místo",
        isMultilang: true,
      }),
      new Switch({
        key: "custom_seo_data",
        label: "Vlastní metadata",
        isMultilang: true,
        labelFalse: "Vygenerovaná metadata",
      }),
      new Textbox({
        key: "seo_title",
        label: "Titulek",
        validators: [],
        isMultilang: true,
        boundTo: "custom_seo_data",
      }),
      new Textarea({
        key: "seo_description",
        label: "Popisek",
        validators: [],
        isMultilang: true,
        boundTo: "custom_seo_data",
      }),
      new Textbox({
        key: "year",
        type: "number",
        label: "Rok",
      }),
      new ContainedMany({
        key: "files",
        label: "Galerie",
        upload: true,
        apiUrl: "files",
        imgOnly: true,
      }),
      new Switch({
        key: "show_on_hp",
        label: "Zobrazit na hlavní straně",
        defaultValue: true,
      }),
    ];
  }

  public formEditors: any;
  public isInitialized = false;
  public isSaving = false;

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute,
    private _entityService: EntityService
  ) {
    super(_formService, _apiService, _router, _alertService);
  }

  ngOnInit() {
    if (typeof this._route.snapshot.params["id"] !== "undefined") {
      this._id = this._route.snapshot.params["id"];
    }

    if (this._route.outlet === "modal-form") {
      this.isModal = true;
      this._redirect = undefined;
      this._saveCallback = this._saveCallback = (response) => {
        const item = { ...response }.data;
        this._entityService.setChosenEntities([item], "testimonials");
        this._closeCallback();
      };
      this._closeCallback = () => {
        this._router.navigate([{ outlets: { "modal-form": null } }], {
          relativeTo: this._route.parent,
        });
      };
      this._id = undefined; // TODO: better?
      window.scrollTo(0, 0);
    }

    this._getEntity();
  }
}
